var CalendarDataTestId = /* @__PURE__ */ ((CalendarDataTestId2) => {
  CalendarDataTestId2["CALENDAR_PREVIOUS_MONTH_BUTTON"] = "calendar-previous-month";
  CalendarDataTestId2["CALENDAR_NEXT_MONTH_BUTTON"] = "calendar-next-month";
  return CalendarDataTestId2;
})(CalendarDataTestId || {});
export {
  CalendarDataTestId
};
